// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import type { PolishSearchFilterType } from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import { alphaAbbreviations } from '@src/utils/displayMaps';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as PolishContent from '@components/popups/content/Polish';

const steps = ['Excellent', 'Very Good', 'Good', 'Fair'];
const abbreviatedSteps = steps.map(step => alphaAbbreviations[step]);
const baseSliderOpts = {
  range: {
    min: 0,
    max: steps.length
  },
  step: 1,
  margin: 1,
  connect: [false, true, false]
};

function getStartValues(stateValues = []) {
  if (stateValues.length === 0) return [0, steps.length];

  let min = steps.length; // start at the max possible
  let max = 0; // start at the min possible

  stateValues.forEach(value => {
    const index = abbreviatedSteps.indexOf(value);
    if (min > index) min = index;
    if (max < index) max = index;
  });

  return [min, max + 1];
}

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: PolishSearchFilterType | void
};

const Popup = () => <QuestionMarkPopup initialContent={PolishContent} />;

export default class PolishSlider extends React.Component<PropsType> {
  render() {
    const sliderOpts = {
      ...baseSliderOpts,
      start: getStartValues(this.props.value)
    };

    return (
      <GenericSlider
        title={'Polish'}
        sliderMarginTop={'0'}
        titleMarginBottom={'2px'}
        sliderOpts={sliderOpts}
        onSliderUpdate={steps => {
          // $FlowFixMe
          const uiSteps = steps.map(step => alphaAbbreviations[step]);
          this.props.onSliderUpdate('UPDATE_POLISH', uiSteps);
        }}
        Popup={Popup}
        steps={steps}
      />
    );
  }
}
